import React, { useState, useEffect } from 'react';
import { Badge, Button, Tooltip } from 'antd';
import { MessageOutlined, CloseOutlined } from '@ant-design/icons';
import ChatContext, { useChat } from '../../contexts/ChatContext';
import ChatContainer from './ChatContainer';

const ChatButton = ({ quoteId, style, className = '' }) => {
  const { unreadCount, isConnected } = useChat();
  const [isOpen, setIsOpen] = useState(false);
  const [wasOpened, setWasOpened] = useState(false);

  // Auto-open chat if quoteId is provided and chat hasn't been opened yet
  useEffect(() => {
    if (quoteId && !wasOpened) {
      setIsOpen(true);
      setWasOpened(true);
    }
  }, [quoteId, wasOpened]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!wasOpened) setWasOpened(true);
  };

  const buttonText = quoteId ? 'Contacter le déménageur' : 'Messages';
  const buttonIcon = isOpen ? <CloseOutlined /> : <MessageOutlined />;

  return (
    <>
      <Tooltip 
        title={isOpen ? 'Fermer le chat' : 'Ouvrir le chat'}
        placement="left"
      >
        <Button
          type="primary"
          icon={buttonIcon}
          onClick={toggleChat}
          className={`fixed bottom-6 right-6 z-50 shadow-lg ${className}`}
          style={style}
        >
          {buttonText}
          {unreadCount > 0 && (
            <Badge 
              count={unreadCount} 
              className="absolute -top-2 -right-2"
              style={{ 
                boxShadow: '0 0 0 2px #fff',
                backgroundColor: isConnected ? '#ff4d4f' : '#faad14' 
              }}
            />
          )}
        </Button>
      </Tooltip>

      {isOpen && (
        <div className="fixed bottom-20 right-6 w-96 h-[600px] bg-white dark:bg-gray-900 rounded-lg shadow-2xl overflow-hidden z-50 flex flex-col">
          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">
              {quoteId ? 'Contacter le déménageur' : 'Messages'}
            </h3>
            <Button 
              type="text" 
              icon={<CloseOutlined />} 
              onClick={toggleChat}
              size="small"
            />
          </div>
          <div className="flex-1 overflow-hidden">
            <ChatContainer quoteId={quoteId} onClose={toggleChat} />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatButton;
